import React from 'react';
import PropTypes from 'prop-types';

const HelpPanel: React.FC<Props> = () => {
  return <h6>Support</h6>;
};

const propTypes = {};

type Props = PropTypes.InferProps<typeof propTypes>;

HelpPanel.propTypes = propTypes;

HelpPanel.defaultProps = {};

export default HelpPanel;
